module.exports = __webpack_public_path__ + "img/lock.3815b9f9.png";